<script lang="ts">
    import { RewardsTranslationNamespaces } from "@apps/rewards/constants/constants";
    import { Observable } from "rxjs";

    import T from "@components/T.svelte";

    import RewardsCustomerStatusBasedContent from "../../RewardsCustomerStatusBasedContent.svelte";

    //Props
    export let isCustomer: boolean;
    export let tierConditionValue$: Observable<string>;
    export let tierProgress$: Observable<string>;
    export let namespace: RewardsTranslationNamespaces;
</script>

<RewardsCustomerStatusBasedContent isCustomerContent={isCustomer}>
    <T
        slot="customer-content"
        {namespace}
        translationKey="vip_tiers_spent_amount"
        translationOptions={{
            progress: $tierProgress$,
            amount: $tierConditionValue$,
        }}
    />
    <T
        slot="default-content"
        {namespace}
        translationKey="vip_tiers_spend_amount"
        translationOptions={{
            amount: $tierConditionValue$,
        }}
    />
</RewardsCustomerStatusBasedContent>
